import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Frown } from "lucide-react";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-background text-foreground">
      <div className="text-center p-8 max-w-md mx-auto">
        <Frown className="w-24 h-24 text-primary mx-auto mb-6 animate-bounce-slow" />
        <h1 className="mb-4 text-6xl font-extrabold text-primary">404</h1>
        <p className="mb-4 text-2xl font-semibold">Oops! Página não encontrada.</p>
        <p className="mb-8 text-muted-foreground">
          Parece que a página que você está procurando não existe ou foi movida.
          Verifique o URL ou tente voltar para a página inicial.
        </p>
        <Button size="lg" className="bg-gradient-primary hover:shadow-glow transition-all duration-300 text-lg px-8 py-6" asChild>
          <Link to="/">Voltar para a Página Inicial</Link>
        </Button>
      </div>
    </div>
  );
};

export default NotFound;
